module.exports = __webpack_public_path__ + "img/7H.42ad9cc6.png";